import { smallStore } from 'stores/smallStore/smallStore'
import type { TAvailablePreset } from 'stores/userDetailsStore/helperTypes'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'
import { apiFetch } from 'utils/apiFetch'
import { setSelectedPreset } from 'utils/setSelectedPreset/setSelectedPreset'
import type { TNewPresetState } from '../Presets'

export const submitEditedPreset = async ({ newPresetState }: { newPresetState: TNewPresetState }) => {
  const editingIdHash = newPresetState.editingIdHash as NonNullable<TNewPresetState['editingIdHash']>

  userDetailsStore.setState((s) => ({
    ...s,
    availableUserDefinedPresets: {
      ...s.availableUserDefinedPresets,
      [editingIdHash]: {
        ...(s.availableUserDefinedPresets?.[editingIdHash] as TAvailablePreset),
        ...newPresetState,
      },
    },
  }))

  if (smallStore.getState().selectedPreset === editingIdHash) setSelectedPreset(editingIdHash)

  return apiFetch({
    url: '/app-presets-management',
    body: {
      editedUserDefinedPresets: {
        [editingIdHash]: {
          name: newPresetState.name as string,
          dayOffsetDateFrom: newPresetState.dayOffsetDateFrom as number,
          dayOffsetDateTo: newPresetState.dayOffsetDateTo as number,
          selectedValueGroups: newPresetState.selectedValueGroups as string[],
          valueGroupForMap: newPresetState.valueGroupForMap as string,
        },
      },
    },
  }).catch(() => {
    // TODO: errorLogger
  })
}
